import React, { useState } from 'react';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';

import SmallProject from './SmallProject';

const AdditionalProjects = () => {
  const [currentCard, setCurrentCard] = useState(1);
  const [prevCard, setPrevCard] = useState(0);
  const [nextCard, setNextCard] = useState(2);

  const increaseCard = (card) => {
    if (card === cardData.length - 1) {
      return 0;
    } else {
      return ++card;
    }
  };
  const decreaseCard = (card) => {
    if (card === 0) {
      return cardData.length - 1;
    } else {
      return --card;
    }
  };

  const nextBtn = () => {
    setPrevCard(increaseCard(prevCard));
    setCurrentCard(increaseCard(currentCard));
    setNextCard(increaseCard(nextCard));
  };
  const prevBtn = () => {
    setPrevCard(decreaseCard(prevCard));
    setCurrentCard(decreaseCard(currentCard));
    setNextCard(decreaseCard(nextCard));
  };

  const cardData = [
    {
      title: 'Find your hat',
      p: 'Find your hat is a game that runs on Node.',
      l: 'GitHub Repo',
      lRef: 'https://github.com/danboyce92/NodeGame',
    },
    {
      title: 'Tic Tac Toe',
      p: 'A version of the classic game Tic-Tac-Toe.',
      l: 'Play game here',
      lRef: 'https://tictactoe-zeta-murex.vercel.app/',
    },
    {
      title: 'Nordic Translator',
      p: 'A simple app that translates input into 5 different Nordic languages',
      l: 'Try it here',
      lRef: 'https://nordic-translator.vercel.app/',
    },
    {
      title: 'Sight-Reader',
      p: 'A countdown game that tests your music sight reading skills',
      l: 'Play it here',
      lRef: 'https://sight-reader.vercel.app/',
    },
  ];

  const cardCarousel = [
    <SmallProject
      id="fyh"
      title={cardData[0].title}
      para={cardData[0].p}
      link={cardData[0].l}
      linkRef={cardData[0].lRef}
    />,
    <SmallProject
      id="ttt"
      title={cardData[1].title}
      para={cardData[1].p}
      link={cardData[1].l}
      linkRef={cardData[1].lRef}
    />,
    <SmallProject
      id="nt"
      title={cardData[2].title}
      para={cardData[2].p}
      link={cardData[2].l}
      linkRef={cardData[2].lRef}
    />,
    <SmallProject
      id="sr"
      title={cardData[3].title}
      para={cardData[3].p}
      link={cardData[3].l}
      linkRef={cardData[3].lRef}
    />,
  ];

  return (
    <div id="final-grad">
      <div id="additional-projects">
        <div className="caro-btn" id="left-btn" onClick={prevBtn}>
          <FaChevronLeft size={50} />
        </div>
        <div className="caro-btn" id="right-btn" onClick={nextBtn}>
          <FaChevronRight size={50} />
        </div>
        <div id="a-p-shader-left"></div>
        <div id="a-p-shader-right"></div>
        <div className="carousel">
          {cardCarousel[prevCard]}
          {cardCarousel[currentCard]}
          {cardCarousel[nextCard]}
        </div>
      </div>
      <div id="more">More added as new technology is explored.</div>
    </div>
  );
};

export default AdditionalProjects;
